<template>
    <div class="c-rkw-content__big-wrap" v-if="item !== null">
        <div class="o-container c-rkw-content__headerbox">
            <a href="https://www.erfolgreich-digitalisieren.de" target="_blank" class="logo"></a>
            <div class="c-rkw-content__breadcrumb">
                <span class="c-rkw-content__breadcrumb-item">{{model.title}}</span>
                <span class="c-rkw-content__breadcrumb-item">{{mechanism.title}}</span>
                <span class="c-rkw-content__breadcrumb-item">{{task.title}}</span>
            </div>
            <a href="#" data-title="Fenster schließen" v-on="{ mouseenter: showTooltip, mouseleave: hideTooltip, mousemove: moveMouse }" class="c-rkw-modal__nav-zoomIn" @click.prevent="toggleZoom"></a>
            <a href="#" class="bookmarks bookmarks-detail c-rkw-bookmark-modal__open" @click.prevent="toggleBookmarkModal" data-title="Ihre Merkliste" v-on="{ mouseenter: showTooltip, mouseleave: hideTooltip, mousemove: moveMouse }"></a>
            <a href="#" class="c-rkw-tutorial" @click.prevent="toggleTutorial" data-title="Tutorial starten" v-on="{ mouseenter: showTooltip, mouseleave: hideTooltip, mousemove: moveMouse }"></a>
            <a class="c-rkw-pdf" @click="createPDF" data-title="PDF generieren" v-on="{ mouseenter: showTooltip, mouseleave: hideTooltip, mousemove: moveMouse }"></a>
        </div>
        <div class="o-container-large c-rkw-content__oversize-container">
            <div class="c-rkw-content__slider c-rkw-slider" v-touch:swipe.left="setNextImage" v-touch:swipe.right="setPrevImage">
                <div v-for="(image, imageIndex) in item.sliderImages" class="c-rkw-slider__item">
                    <figure class="c-rkw-slider__image" :style="'background-image: url(' + settings.pageUrl + image[0] + ')'" v-bind:class="{'c-rkw-slider__image--active': (imageIndex === activeImage)}">

                    </figure>
                </div>
                <div class="c-rkw-slider__prev" @click.prevent="clickPrevImage"></div>
                <div class="c-rkw-slider__next" @click.prevent="clickNextImage"></div>
                <div class="c-rkw-slider__nav">
                    <span v-for="(image, imageIndex) in item.sliderImages" class="c-rkw-slider__bullet" v-bind:class="{'c-rkw-slider__bullet--active': (imageIndex === activeImage)}" @click.prevent="clickImage(imageIndex)"></span>
                </div>
            </div>
        </div>
        <div class="o-container">
            <div class="o-grid u-fd-rowrev">
                <div class="o-grid__col u-8/12 u-4/4@mobile">
                    <div class="c-rkw-content__buttons c-rkw-content__buttons--relative">
                        <span v-if="!isBookmarked(uid)" class="c-rkw-content__button c-rkw-content__button--like" v-on:click="addBookmark(uid, 'bookmarks-detail', $event)"></span>
                        <span v-if="isBookmarked(uid)" class="c-rkw-content__button c-rkw-content__button--unlike" v-on:click="removeBookmark(uid)"></span>
                    </div>
                    <h3 class="c-rkw-content__header">
                        {{item.content.header}}
                    </h3>
                    <span class="c-rkw-content__subheader">{{item.content.subheader}}</span>
                    <p class="c-rkw-content__body">
                        <strong>{{item.content.teaser}}</strong>
                    </p>
                    <div class="c-rkw-content__body" v-html="item.content.text"></div>
                    <div class="c-rkw-content__videos o-grid">
                        <div class="o-grid__col u-6/12" v-for="video in item.videos">
                            <div v-if="video.flag === 'youtube'">

                                <iframe style="min-height: 30rem;" :src="video.embed" frameborder="0" allow="autoplay; encrypted-media" class="c-rkw-content__video-item c-rkw-content__video-item--player" allowfullscreen></iframe>
                                <p class="c-rkw-content__body">{{video.title}}</p>
                            </div>
                            <div v-if="video.flag === 'mp4'">
                                <video controls loop class="c-rkw-content__video-item c-rkw-content__video-item--player">
                                    <source :src="settings.pageUrl + video.url" type="video/mp4">
                                </video>
                                <p class="c-rkw-content__body">{{video.title}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="o-grid__col u-4/12 u-4/4@mobile">
                    <div class="o-grid">
                        <div class="o-grid__col u-10/12 u-4/4@mobile">
                            <hr class="c-rkw-content__line c-rkw-content__line--small">
                            <p class="c-rkw-content__body">
                                <span v-if="item.metaContent.company">{{item.metaContent.company}}<br></span>
                                <span v-if="item.metaContent.business">Branche: {{item.metaContent.business}}<br></span>
                                <span v-if="item.metaContent.employee">Mitarbeiter: {{item.metaContent.employee}}<br></span>
                                <span v-if="item.metaContent.place">{{item.metaContent.place}}<br></span>
                                <span v-if="item.metaContent.website"><a class="c-rkw-content__link" :href="getHttpWebsite(item.metaContent.website)" target="_blank">{{getWebsite(item.metaContent.website)}}</a></span>
                            </p>
                            <div v-if="item.downloads.length > 0">
                                <hr class="c-rkw-content__line c-rkw-content__line--small">
                                <p class="c-rkw-content__body">
                                    <strong>Downloads:</strong><br>
                                    <a v-for="download in item.downloads" :href="settings.pageUrl + download[1]" class="c-rkw-content__download" target="_blank">{{download[0]}}<br></a>
                                </p>
                            </div>
                            <div v-if="item.links.length > 0">
                                <hr class="c-rkw-content__line c-rkw-content__line--small">
                                <p class="c-rkw-content__body">
                                    <strong>Weitere Informationen zum Beispiel:</strong><br>
                                    <a v-for="link in item.links" :href="link.url" class="c-rkw-content__ext-link" target="_blank">{{link.title}}<br></a>
                                </p>
                            </div>
                            <div v-if="item.linksSimilar.length > 0">
                                <hr class="c-rkw-content__line c-rkw-content__line--small">
                                <p class="c-rkw-content__body">
                                    <strong>Ähnliche Beispiele:</strong><br>
                                    <a v-for="link in item.linksSimilar" :href="link.url" class="c-rkw-content__ext-link" target="_blank">{{link.title}}<br></a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="o-grid">
                <div class="o-grid__col u-12/12">
                    <div class="c-rkw-content__mechanism-info">
                        <div class="o-grid">
                            <div class="o-grid__col u-4/12  u-4/4@mobile" style="text-align: center;">
                                <mechanism-image :color="color"></mechanism-image>
                            </div>
                            <div class="o-grid__col u-8/12 u-4/4@mobile" :style="`color: ${color}; padding-top: 3rem;`">
                                <div class="o-grid">
                                    <div class="o-grid__col u-9/12 u-4/4@mobile">
                                        <h3 class="c-rkw-content__header c-rkw-content__header--italic">
                                            {{task.infoTitle}}
                                        </h3>
                                    </div>
                                </div>
                                <div class="o-grid">
                                    <div class="o-grid__col u-10/12 u-4/4@mobile">
                                        <p class="c-rkw-content__body c-rkw-content__body--weight-invert" v-html="task.infoText"></p>
                                    </div>
                                    <div class="o-grid__col u-7/12 u-4/4@mobile"></div>
                                    <div class="o-grid__col u-5/12 u-4/4@mobile">
                                        <div class="o-grid">
                                            <div class="o-grid__col u-8/8">
                                                <p class="" :style="`color: ${color};`"><strong>Teilen:</strong></p>
                                                <a :href="sharing.facebook" target="_blank" class="c-rkw-content__share-item c-rkw-content__share-item--facebook" :style="`color: ${color};`"></a>
                                                <a :href="sharing.twitter" target="_blank" class="c-rkw-content__share-item c-rkw-content__share-item--twitter" :style="`color: ${color};`"></a>
                                                <a :href="sharing.linkedin" target="_blank" class="c-rkw-content__share-item c-rkw-content__share-item--linkedin" :style="`color: ${color};`"></a>
                                                <a :href="sharing.xing" target="_blank" class="c-rkw-content__share-item c-rkw-content__share-item--xing" :style="`color: ${color};`"></a>
                                                <a :href="sharing.mail" class="c-rkw-content__share-item c-rkw-content__share-item--email" :style="`color: ${color};`"></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="o-grid">
                <div class="o-grid__col u-4/12 u-4/4@mobile">
                    <h4 class="c-rkw-content__header">Sie suchen Beratung?<br>Sprechen Sie uns an!</h4>
                    <p class="c-rkw-content__body">
                        Unsere Landesvereine unterstützen Unternehmen direkt vor Ort mit Beratung, Weiterbildung und anderen Dienstleistungen. Finden Sie Ihren persönlichen Ansprechpartner, in dem Sie Ihr Bundesland auswählen.
                    </p>
                </div>
                <div class="o-grid__col u-4/12 u-4/4@mobile">
                    <div class="c-rkw-content__contact">
                        <div class="c-rkw-content__contact-header c-rkw-content__contact-header--short"></div>
                        <div class="c-rkw-content__contact-selection">
                            Ihr Ansprechpartner in der Nähe<br>
                            <select-box v-model="selectedContact" :options="$store.state.data.contacts['filter']"> </select-box>
                        </div>
                        <div class="c-rkw-content__contact-person" v-if="selectedContact">
                            <strong v-if="selectedContact.name">{{selectedContact.name}}<br></strong>
                            <span v-if="selectedContact.function">{{selectedContact.function}}<br></span>
                            <span v-if="selectedContact.street">{{selectedContact.street}}<br></span>
                            <span v-if="selectedContact.city">{{selectedContact.city}}<br></span>
                            <br>
                            <span v-if="selectedContact.phone">Tel: {{selectedContact.phone}}<br></span>
                            <span v-if="selectedContact.email">eMail: {{selectedContact.email}}<br></span>
                        </div>
                    </div>
                </div>
                <span class="c-rkw-content__contact-divider"></span>
                <div class="o-grid__col u-4/12 u-4/4@mobile">
                    <div class="c-rkw-content__contact">
                        <div class="c-rkw-content__contact-header"></div>
                        <div class="c-rkw-content__contact-selection">
                            Ihre Ansprechpartnerin für das<br>
                            RKW-Digitalisierungs-Cockpit:
                        </div>
                        <div class="c-rkw-content__contact-person">
                            <strong v-if="contact.name">{{contact.name}}<br></strong>
                            <span v-if="contact.function">{{contact.function}}<br></span>
                            <span v-if="contact.street">{{contact.street}}<br></span>
                            <span v-if="contact.city">{{contact.city}}<br></span>
                            <br>
                            <span v-if="contact.phone">Tel: {{contact.phone}}<br></span>
                            <span v-if="contact.email">eMail: {{contact.email}}<br></span>
                        </div>
                    </div>
                </div>
            </div>
            <content-slider :instances="relatedInstances" :active-instance="uid" :model="model"> </content-slider>
            <hr class="c-rkw-content__line">
            <div class="o-grid c-rkw-footer">
                <div class="o-grid__col u-4/12 u-4/4@mobile">
                    <p class="c-rkw-content__body c-rkw-footer__copyright">Copyright @ RKW {{currentYear}}</p>
                </div>
                <div class="o-grid__col u-8/12 u-4/4@mobile">
                    <p class="c-rkw-content__body">
                        <a v-for="link in footer" class="c-rkw-footer__link" target="_blank" :href="link[1]">{{link[0]}}</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import mixins from "../mixins"

    var pdfMake = require('pdfmake/build/pdfmake.js');
    var pdfFonts = require('pdfmake/build/vfs_fonts.js');
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    var htmlToPdfMake = require("html-to-pdfmake");
    /*import imagePdf from '../../assets/img/logo.png'*/

    export default {
        data () {
            return {
                activeImage: 0,
                selectedContact: null,
                intVal: null
            }
        },
        head: {
            title() {
                return {
                    inner: this.title
                }
            },
            link () {
                return [
                    { rel: 'canonical', href: this.settings.pageUrl + '/#/beispiel/' + this.getInstanceURI(this.uid), id: 'canonical' }
                ]
            },
            meta () {
                return [
                    { name: 'description', content: this.metaInformation.description, id: 'desc' },
                    { name: 'twitter:card', content: 'summary', id:'twittercard' },
                    { name: 'twitter:title', content: this.metaInformation.title, id:'twittertitle' },
                    { name: 'twitter:description', content: this.metaInformation.description, id:'twitterdesc' },
                    { property: 'og:title', content: this.metaInformation.title, id:'fbtitle' },
                    { property: 'og:description', content: this.metaInformation.description, id:'fbdesc' },
                    { property: 'og:url', content: this.metaInformation.url, id:'fburl' },
                    { property: 'og:image', content: this.metaInformation.image, id:'fbimage' }
                ]
            }
        },
        watch: {
            'uid' () {
                this.activeImage = 0
                this.undoIntval()
                this.doIntval()
                this.$emit('updateHead')
            }
        },
        created () {
            //this.selectedContact = this.$store.state.data['contacts']['global']
            // console.log(this.relatedInstances)
        },
        mounted () {
            this.undoIntval()
            this.doIntval()
        },
        mixins: [mixins],
        computed: {
            title () {
                return this.item.content.header + ' - ' + this.item.content.subheader
            },
            metaInformation () {
                return {
                    description: (this.item.metaContent.metaDescription) ? this.item.metaContent.metaDescription : this.item.content.subheader,
                    title: this.task.title,
                    url: this.settings.pageUrl,
                    image: this.settings.pageUrl + this.item.sliderImages[0][0]
                }
            },
            sharing () {
                return {
                    twitter: 'https://twitter.com/intent/tweet?url=' + document.URL,
                    facebook: 'https://www.facebook.com/sharer.php?u=' + document.URL,
                    linkedin: 'https://www.linkedin.com/shareArticle?mini=true&url=' + document.URL + '&title='+this.metaInformation.title,
                    xing: 'https://www.xing.com/spi/shares/new?url=' + document.URL,
                    mail: 'mailto:Empfänger eingeben?subject='+this.metaInformation.title+'&body=' + document.URL
                }
            },
            settings () {
                return this.$store.state.settings
            },
            footer () {
                return this.$store.state.data.footer
            },
            footer () {
                return this.$store.state.data.footer
            },
            uid () {
                return parseInt(this.$store.state.runtime.activeItems['instance'])
            },
            item () {
                return (this.$store.state.runtime.activeItems['instance'] === null)
                    ? null
                    : this.$store.state.data['instances'][this.$store.state.runtime.activeItems['instance']]
            },
            model () {
                return this.$store.state.data['models']['uid' + this.$store.state.runtime.activeItems['model']]
            },
            mechanism () {
                return this.$store.state.data['mechanisms'][this.$store.state.runtime.activeItems['mechanism']]
            },
            task () {
                return this.$store.state.data['tasks'][this.$store.state.runtime.activeItems['task']]
            },
            color () {
                return (this.item !== null) ? this.$store.state.settings.colors[this.model['color']] : ""
            },
            flip () {
                return this.$store.state.runtime.content.flip
            },
            zoom () {
                return this.$store.state.runtime.content.zoom
            },
            contact () {
                return this.$store.state.data['contacts']['global']
            },
            relatedInstances () {
                let arr = this.$store.state.runtime.allItems.related[this.model.id]
                return  arr.filter(ins => parseInt(ins) !== parseInt(this.uid))
            },
            currentYear (){
                 return new Date().getFullYear()
            }
        },
        methods: {
            setActive (instanceId) {
                this.setActiveInstance(instanceId)
            },
            getActive () {
                return this.$store.state.runtime.activeItems['instance']
            },
            setInactive () {
                this.$store.commit('unsetActiveInstance')
            },
            toggleFlip () {
                this.$store.commit('toggleContentFlip')
                return this.flip
            },
            toggleZoom () {
                this.$store.commit('toggleContentZoom')
                return this.zoom
            },
            getNextInstance () {
                let next = this.findNextItem(this.$store.state.runtime.allItems['instances'], this.$store.state.runtime.activeItems['instance'])
                if(next !== false) {
                    this.setActive(next)
                }
            },
            getPrevInstance () {
                let prev = this.findPrevItem(this.$store.state.runtime.allItems['instances'], this.$store.state.runtime.activeItems['instance'])
                if(prev !== false) {
                    this.setActive(prev)
                }
            },
            setNextImage () {
                if(this.item && this.item.sliderImages)
                    this.activeImage = (this.activeImage === this.item.sliderImages.length - 1) ? 0 : this.activeImage + 1
            },
            setPrevImage () {
                if(this.item && this.item.sliderImages)
                    this.activeImage = (this.activeImage === 0) ? this.item.sliderImages.length - 1 : this.activeImage - 1
            },
            getWebsite (url) {
                let f = url.split('//')
                if(f.length > 1) {
                    return f[1].split('/')[0]
                } else {
                    return url
                }
            },
            getHttpWebsite (url) {
                if(url.indexOf('http') === -1) {
                    return 'http://' + url
                } else {
                    return url
                }
            },
            doIntval () {
                if(this.item && this.item.sliderImages.length) {
                    this.intVal = window.setInterval(() => {
                        this.setNextImage()
                    }, 2500)
                }
            },
            undoIntval () {
                if(this.item && this.item.sliderImages.length) {
                    window.clearInterval(this.intVal)
                    this.intVal = null
                }
            },
            clickNextImage () {
                this.undoIntval()
                this.setNextImage()
            },
            clickPrevImage () {
                this.undoIntval()
                this.setPrevImage()
            },
            clickImage (image) {
                this.undoIntval()
                this.activeImage = image
            },
            createPDF() {
                var htmlPdf = htmlToPdfMake(
                    "<div>" +
                    "<img class='rkw-image' width='50px' src='data:image/png;base64,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'>" +
                    "<h5>RKW Digitalisierungs-Cockpit</h5>" +
                    "<br/>" +
                    "<h1>" + this.item.content.header + "</h1>" +
                    "<strong>" + this.item.content.teaser + "</strong>" +
                    "<br/>" +
                    this.item.content.text +
                    "<br/><br/>" +
                    "<strong>" + this.task.infoTitle + "<strong>" +
                    "<br/>" +
                    this.task.infoText +
                    "</div>"
                );

                var docDefinition = {
                    info : {
                        title : 'RKW Digitalisierungscockpit: ' + this.item.content.header
                    },
                    content: [
                        htmlPdf
                    ],
                    styles: {
                        h1: {
                          fontSize: 22,
                          bold: true
                        },
                        'rkw-image': {
                            marginLeft: 450
                        }
                      }
                };

                pdfMake.createPdf(docDefinition).download('rkw_digicockpit_' + this.item.content.header.toLowerCase().replace(/ /g, "_") + '.pdf');
            }
        }
    }
</script>


// WEBPACK FOOTER //
// ContentDetail.vue?1a9aa268